import { addFilter } from '@wordpress/hooks';
import { Fragment } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import PaddingControl from '../../extensions/controls/padding-control';
import MarginControl from '../../extensions/controls/margin-control';
import styling from './inline-styles';
import Accordion from '../../components/Accordion';

const SpacingControls = ( props ) => {
	return <Accordion tabs={ [
		{
			name: 'button',
			initialOpen: true,
			label: () => {
				return __( 'Space' );
			},
			cb: () => {
				return <>
					<PaddingControl
						{ ...props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Padding' ) }
						property="padding"
						onChange={ () => {} }
					/>
					<MarginControl
						{ ...props }
						parentKey="blockAdvanceOptions"
						label={ __( 'Margin' ) }
						onChange={ () => {} }
					/>
				</>;
			},
		},
	] } />;
};

// Enable Responsive disply control on the following blocks
const enabledBlocks = [
	'button',
	'container',
	'gallery-carousel',
	'icon',
	'info-box',
	'map',
	'post-carousel',
	'section-title',
	'service',
	'star-rating',
	'team-member',
	'team',
	'testimonial',
	'testimonials',
];

enabledBlocks.forEach( ( block ) => {
	addFilter( `gutenify-block-${ block }-options-tab-advance`, `Gutenify/Block/${ block }/InspectorControls/BasicControls/tabs/advance`, ( content, props ) => {
		return [ ...content, <SpacingControls key={ `gutenify-block-${ block }-options-tab-content-basic` } { ...props } /> ];
	} );

	addFilter( `gutenify--${ block }--inline-styles`, `gutenify--${ block }--inline-styles--space`, ( content, props ) => {
		return content + styling( props );
	} );
} );
